import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const MOVEMENTS_MANAGEMENT_SIDENAV_LINKS = new InjectionToken<void>("MOVEMENTS_MANAGEMENT_SIDENAV_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("movements-management", [
      {
        id: "movements",
        label: "MOVEMENTS_MANAGEMENT.ITEMS.MOVEMENTS",
        icon: "car-location",
        routerLink: "/movements-management/movements",
        permissions: COMMON_GUARD_OPTIONS.MOVEMENT.VIEW.permissions,
      },
      {
        id: "vehicleBlocks",
        label: "MOVEMENTS_MANAGEMENT.ITEMS.VEHICLE_BLOCKS",
        icon: "block",
        routerLink: "/movements-management/vehicle-blocks",
        permissions: COMMON_GUARD_OPTIONS.VEHICLE_BLOCK.VIEW.permissions,
      },
      {
        id: "vehicleTransfer",
        label: "MOVEMENTS_MANAGEMENT.ITEMS.VEHICLE_TRANSFER",
        icon: "vehicle-transfer",
        routerLink: "/movements-management/vehicle-transfer",
        permissions: COMMON_GUARD_OPTIONS.VEHICLE_TRANSFER.VIEW.permissions,
      },
      {
        id: "configurations",
        label: "MOVEMENTS_MANAGEMENT.ITEMS.CONFIGURATIONS",
        icon: "configuration",
        expanded: true,
        items: [
          {
            id: "vehicleBlockType",
            label: "MOVEMENTS_MANAGEMENT.ITEMS.VEHICLE_BLOCK_TYPE",
            routerLink: "/movements-management/vehicle-block-type",
            permissions: COMMON_GUARD_OPTIONS.VEHICLE_BLOCK_TYPE.VIEW.permissions,
          },
          {
            id: "movementType",
            label: "MOVEMENTS_MANAGEMENT.ITEMS.MOVEMENT_TYPE",
            routerLink: "/movements-management/movement-type",
            permissions: COMMON_GUARD_OPTIONS.MOVEMENT_TYPE.VIEW.permissions,
          },
          {
            id: "stepConfiguration",
            label: "MOVEMENTS_MANAGEMENT.ITEMS.STEP_CONFIGURATION",
            routerLink: "/movements-management/step-configuration",
            permissions: COMMON_GUARD_OPTIONS.STEP_CONFIGURATION.VIEW.permissions,
          },
          {
            id: "photoType",
            label: "MOVEMENTS_MANAGEMENT.ITEMS.PHOTO_TYPE",
            routerLink: "/movements-management/photo-type",
            permissions: COMMON_GUARD_OPTIONS.PHOTO_TYPE.VIEW.permissions,
          },
          // Equipment configuration.
          {
            id: "equipment",
            label: "MOVEMENTS_MANAGEMENT.ITEMS.EQUIPMENT",
            routerLink: "/movements-management/equipment",
            permissions: COMMON_GUARD_OPTIONS.EQUIPMENT.VIEW.permissions,
          },
          // Reasons management: reason settings and reason lists.
          {
            id: "reasons",
            label: "MOVEMENTS_MANAGEMENT.ITEMS.REASONS",
            routerLink: "/movements-management/reasons",
            permissions: COMMON_GUARD_OPTIONS.REASON_SETTINGS.VIEW.permissions,
          },
          // General settings: singleton settings pages; the group hides itself when none of its pages is allowed.
          {
            id: "generalSettings",
            label: "MOVEMENTS_MANAGEMENT.ITEMS.GENERAL_SETTINGS",
            items: [
              {
                id: "multiVehicleTransferSettings",
                label: "MOVEMENTS_MANAGEMENT.ITEMS.MULTI_VEHICLE_TRANSFER_SETTINGS",
                routerLink: "/movements-management/multi-vehicle-transfer-settings",
                permissions: COMMON_GUARD_OPTIONS.MULTI_VEHICLE_TRANSFER_SETTINGS.VIEW.permissions,
              },
            ],
          },
        ],
      },
    ]);
  },
});
